import { NavLink } from 'react-router-dom'
import { cn } from '../../lib/cn'

interface NavRowProps {
  label: string
  to: string
  /** Numeric or string badge; hidden when 0, '', null or undefined. */
  badge?: number | string | null
  badgeLabel?: string
}

/** A semantic sidebar link with an optional, named count. */
export function NavRow({ label, to, badge, badgeLabel }: NavRowProps) {
  const showBadge = badge !== undefined && badge !== null && badge !== '' && badge !== 0

  return (
    <NavLink
      to={to}
      end={to === '/'}
      aria-label={showBadge ? `${label}, ${badge} ${badgeLabel ?? 'items'}` : label}
      className={({ isActive }) => cn(
        'flex w-full items-center justify-between gap-2 rounded-btn px-[10px] py-[10px] text-left font-sans text-[13.5px] font-medium leading-none transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-terra-deep',
        isActive ? 'bg-ink text-paper-panel' : 'bg-transparent text-ink-soft hover:bg-paper-deep/60',
      )}
    >
      {({ isActive }) => <>
      <span>{label}</span>
      {showBadge && (
        <span
          className={cn(
            'rounded-pill px-[6px] py-[2px] font-mono text-[11px] leading-none',
            isActive ? 'bg-[#4a4136] text-paper-panel' : 'bg-line-soft text-ink-muted',
          )}
          aria-hidden="true"
        >
          {badge}
        </span>
      )}
      </>}
    </NavLink>
  )
}
